const translations = {
  "en": {
    "I'm cross-checking your portfolio.": "I'm digging into your money.\n"
  },
  "zh-tw": {
    "I'm cross-checking your portfolio.": "我正在深入研究你的資金。"
  }
};

export default translations;
